import { render, staticRenderFns } from "./yjjb.vue?vue&type=template&id=7538e3ac&scoped=true"
import script from "./yjjb.vue?vue&type=script&lang=js"
export * from "./yjjb.vue?vue&type=script&lang=js"
import style0 from "./yjjb.vue?vue&type=style&index=0&id=7538e3ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7538e3ac",
  null
  
)

export default component.exports